<template></template>

<script>
export default {
  props:{
    tabsCount: {
      default: 1
    }
  },
  data(){
    return{
      currentTabIndex: 1,
    }
  },
  methods:{
    setActiveTab(id, scrollToCat){
      this.currentTabIndex = id;
      if(scrollToCat) this.scrollToCat(id);
    },
    scrollToCat(id){
        const radioBtn = this.$refs['catItem_'+id];
        const radioBtnHolder = radioBtn.closest(".app-radio-button");
        const catMenuHolder = radioBtnHolder.closest(".app-radio-group");

        const aimCoords = radioBtnHolder.getBoundingClientRect();
        catMenuHolder.scrollLeft = aimCoords.left + catMenuHolder.scrollLeft - 10;
    },
    nextTab(){
      if(this.currentTabIndex === this.tabsCount){
        this.setActiveTab(1, true);
      }else{
        this.setActiveTab(++this.currentTabIndex, true);
      }
    },
    prevTab(){
      if(this.currentTabIndex === 1){
        this.setActiveTab(this.tabsCount, true);
      }else{
        this.setActiveTab(--this.currentTabIndex, true);
      }
    },
  },
}
</script>

<style scoped>

</style>